import { render, staticRenderFns } from "./PostTrainingLessons.vue?vue&type=template&id=1a14ce46&"
import script from "./PostTrainingLessons.vue?vue&type=script&lang=js&"
export * from "./PostTrainingLessons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports